export const resourceImplementationTypes = {
  none: 0,
  online: 1,
  offline: 2,
  mix: 3
}

export const resourceImplementationTypesOptions = [
  { label: 'none', value: resourceImplementationTypes.none },
  { label: 'online', value: resourceImplementationTypes.online },
  { label: 'offline', value: resourceImplementationTypes.offline },
  { label: 'mix', value: resourceImplementationTypes.mix }
]

export const teachersTrainingReferenceId = 'teachersTraining'
export const teachersTrainingName = 'Acompañamiento docente'
